<button hlmBtn size="md" variant="outline" (click)="toggleMenu()" class="lg:hidden">
  @if (menuOpened()) {
    <lucide-icon name="x" size="24" />
  } @else {
    <lucide-icon name="menu" size="20" />
  }
</button>

<div
  class="hide-scrollbar fixed left-0 right-0 top-[101px] z-20 flex h-fit max-h-[calc(100dvh-101px)] w-full translate-x-full flex-col overflow-auto bg-background pt-3 opacity-0 shadow-lg transition-all duration-300"
  [ngClass]="{ '!translate-x-0 !opacity-100': menuOpened() }">
  <nav class="flex flex-col gap-2 md:flex-1">
    <ul class="flex flex-col">
      @for (item of menuItems; track item) {
        <a
          [routerLink]="item.route"
          routerLinkActive="text-gray-900"
          [routerLinkActiveOptions]="{ exact: item.route === PAGE_ROUTES.HOME }"
          (click)="toggleMenu()"
          class="whitespace-nowrap p-3 text-center text-xl text-disabled transition-all duration-200 hover:text-primary">
          {{ item.label }}
        </a>
      }
      <div class="border-t border-gray-200 p-4">
        <div class="flex flex-col gap-3">
          <a
            hlmBtn
            size="lg"
            variant="ghost"
            class="flex w-full items-center justify-center gap-2 text-lg text-muted-foreground hover:text-foreground"
            [href]="employeePortalUrl()"
            (click)="toggleMenu()"
            target="_blank">
            <lucide-icon name="external-link" size="18" />
            Employee Portal
          </a>
          <a hlmBtn size="lg" class="w-full rounded-xl text-lg" variant="default" [routerLink]="PAGE_ROUTES.HIRE_US" (click)="toggleMenu()"
            >Schedule a Consultation</a
          >
        </div>
      </div>
    </ul>
  </nav>
</div>

<div
  (click)="toggleMenu(false)"
  (keydown)="toggleMenu(false)"
  class="overlay fixed bottom-0 left-0 right-0 z-10 h-full max-h-[calc(100dvh-109px)] w-full bg-black/20 transition-all duration-300 md:max-h-[calc(100dvh-121px)]"
  [ngClass]="{
    'visible opacity-100': menuOpened(),
    'invisible opacity-0': !menuOpened(),
  }"></div>
